module.exports = __webpack_public_path__ + "img/logo-dark.0f8b754b.png";